import { Link } from 'react-router-dom';
import { SILKCART_LOGO } from '../../theme/theme';
import './leftMenuLogo.css';
const LeftMenuLogo = ({ collapse }) => <Link to="/home/dashboard" className={`silk-nav-brand ${collapse ? 'compact' : ''}`} aria-label="SilkCart dashboard"><img src={SILKCART_LOGO} alt="SilkCart" />{!collapse && <span>SilkCart<small>ADMIN WORKSPACE</small></span>}</Link>;
export default LeftMenuLogo;
